import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

const Label = styled.span`
  line-height: 1.4;
  font-size: 13px;
  letter-spacing: 0.01em;
  color: ${COLOR.SONIC_SILVER};
  font-weight: 600;
`;

export default Label;
